enum GameState {
  FINISHED = 'finished',
  LTO = 'lto',
  PENDING = 'pending',
  OPEN = 'open',
  SKIPGAME = 'skipgame',
}

export default GameState
